import { TicketListItemDTO } from '@sb-tools/typescript/models/dto/ticket-list-item.dto';

export class TicketBulkAssigneeUpdate {
    previousAssigneeId?: string;
    ticketId: number;

    constructor(ticket: TicketListItemDTO) {
        this.previousAssigneeId = ticket.assignee ? ticket.assignee.id : null;
        this.ticketId = ticket.id;
    }
}
